import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../services/global.service';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from "highcharts/highcharts-more";

@Component({
  selector: 'app-sidebar-component',
  templateUrl: './sidebar-component.component.html',
  styleUrls: ['./sidebar-component.component.scss']
})
export class SidebarComponent implements OnInit {
  constructor(public globalService: GlobalService) { }
  ngOnInit() { }
  ngAfterViewInit() {
  }
  forPopupClose() {
    this.globalService.showPopUp = '';
  }

  makeSideBarActive() {
    this.globalService.sideTrue = true;
    let _this = this;
    setTimeout(function () {
      _this.chartResize();
    }, 0)
  }
  makeSideBarInActive() {
    this.globalService.sideTrue = false;
    let _this = this;
    setTimeout(function () {
      _this.chartResize();
    }, 0)
  }
  chartResize() {
    if (this.globalService.previousSize !== 0) {
      if(document.getElementsByClassName('time-list-wrap') && document.getElementsByClassName('time-list-wrap')[0]){
      let time_list_wrap = document.getElementsByClassName('time-list-wrap')[0]['offsetWidth'];
      let finalWWidth = time_list_wrap - this.globalService.previousSize;
      if(document.getElementById("toDuration") && document.getElementById("fromDuration") ){
      let sec = (+(document.getElementById("toDuration")['value']) - +(document.getElementById("fromDuration")['value']));
      let time_handle_left = document.getElementsByClassName('time-handle')[0]['offsetLeft'];
      if (time_handle_left !== 0) {
        let dividevalue = (finalWWidth / sec);
        if (dividevalue < 0) {
          dividevalue = -dividevalue;
        }
        time_handle_left = (finalWWidth > 0) ? (time_handle_left * dividevalue) : (time_handle_left / dividevalue);
        this.globalService.previousSize = time_list_wrap;
        document.getElementsByClassName('time-handle')[0]['style']['left'] = Math.ceil(time_handle_left) + "px";
      }
    }
  }
    }
    if(Highcharts && Highcharts.charts){
    Highcharts.charts.forEach(chart => {
      if (chart && chart['container'] && chart['container']['parentElement'] && chart['container']['parentElement']['id']) {
        if(document.getElementById(chart['container']['parentElement']['id'])){
        let width = document.getElementById(chart['container']['parentElement']['id']).clientWidth;
        let height = document.getElementById(chart['container']['parentElement']['id']).clientHeight;
        if(chart && width && height)
        chart.setSize(width, height);
        }
      }
    });
  }
    setTimeout(function () {
      let widthNew = document.getElementById('chart-container')?document.getElementById('chart-container').clientWidth:230;
      let widthOtherNew =  document.getElementById('chart-container-kpi')?document.getElementById('chart-container-kpi').clientWidth:450;
      let canvas:any = document.getElementsByClassName('canvas-kpi');
      let canvasUx:any = document.getElementById('canvasux');
      if(canvasUx){
      canvasUx.style.width = widthNew+'px';
      if(canvas && canvas.length){
      for(let i=0;i<canvas.length;i++){
      canvas[i].style.width = widthOtherNew+'px';
      }
    }
      }
    },0);
  }
  toggleSideBar() {
    this.globalService.sideTrue = !this.globalService.sideTrue;
  }
}